import { Box } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

type YearOptionsProps = {
  years: number[];
  selectedYears: { [key: number]: boolean };
  handleYearChange: (year: number) => void;
};

export const YearOptions = ({ years, selectedYears, handleYearChange }: YearOptionsProps) => (
  <Box sx={{ marginLeft: 1, marginBottom: 2 }}>
    {years.map((year) => (
      <FormControlLabel
        key={year}
        control={
          <Checkbox
            checked={!!selectedYears[year]}
            onChange={() => handleYearChange(year)}
          />
        }
        label={year.toString()}
      />
    ))}
  </Box>
);
